/* @flow */

import { rem, setLightness, ellipsis } from 'polished';

import { fadeDuration } from '@e180/ui/lib/token/animation';
import { borderRadius } from 'src/shared/app/base/style/token/box';
import { successColor, cardBaseColor } from '@e180/ui/lib/token/color';
import { antialiasing } from 'src/shared/app/base/style/token/helper';
import { disabledOpacity } from 'src/shared/app/base/style/token/opacity';
import {
  white,
  lightGrey,
  blueGrey,
  darkGrey,
} from '@e180/ui/lib/token/palette';
import { hoverSelector } from '@e180/ui/lib/token/selector';
import { baseFontSize } from '@e180/ui/lib/token/typography';

const lightnessThreshold = 0.85;

export default {
  root: {
    position: 'relative',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    padding: 0,

    backgroundColor: cardBaseColor,
    borderRadius,

    textDecoration: 'none',

    transition: ['background-color', fadeDuration],

    [hoverSelector]: {
      backgroundColor: ({ accentColor }: Object) =>
        setLightness(lightnessThreshold, accentColor),
    },
    '&:active': {
      backgroundColor: ({ accentColor }: Object) => [
        setLightness(lightnessThreshold - 0.1, accentColor),
        '!important',
      ],
    },
    '&:focus': {
      backgroundColor: ({ accentColor }: Object) =>
        setLightness(lightnessThreshold, accentColor),
      outlineWidth: 0,
    },
  },
  'root-isInactive': {
    pointerEvent: 'none',
  },
  'root-isDeclined': {
    opacity: disabledOpacity,
  },
  'root-isToday': {},
  body: {
    position: 'relative',

    display: 'flex',

    padding: [12, 10],
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,

    minWidth: 0,
    marginLeft: rem(10, baseFontSize),
  },
  name: {
    extend: ellipsis(),

    paddingRight: rem(16, baseFontSize),

    color: ({ darkAccentColor }: Object) => darkAccentColor,

    fontSize: 15,
  },
  title: {
    extend: ellipsis(),

    color: darkGrey,

    fontSize: 13,
    fontStyle: 'italic',
    lineHeight: 15 / 13,

    '$root-isDeclined &': {
      color: blueGrey,
    },
  },
  topic: {
    extend: ellipsis(),

    marginTop: rem(4, baseFontSize),

    color: blueGrey,

    fontSize: 13,
    fontWeight: 600,
  },
  badge: {
    position: 'absolute',
    top: 12,
    right: 10,
  },
  bottom: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    padding: [4, 12],

    backgroundColor: lightGrey,
    borderBottomLeftRadius: 'inherit',
    borderBottomRightRadius: 'inherit',
    color: blueGrey,

    fontSize: rem(13, baseFontSize),
    lineHeight: 1,

    transition: ['background-color', fadeDuration],

    '$root-isToday &': {
      extend: antialiasing,

      backgroundColor: successColor,
      color: white,
    },
  },
};
